<div class="mt-4">

  <div class="flex justify-between items-center pl-5 pr-5">
    <div class="text-lg text-gray-700 font-bold ">Editar Ocorrência</div>
    <button mat-button class="btn-close" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>


  <div [formGroup]="form" class="flex flex-col justify-center gap-4 py-2 px-6 items-end">
    <mat-form-field class="input-tg mt-message-input w-full" appearance="outline">
      <mat-label>Descrição</mat-label>
      <input matInput formControlName="description" />
    </mat-form-field>



    <button mat-flat-button class="btn-tg" [disabled]="form.invalid || loading" (click)="editItem()">

      @if (loading) {
      <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
      } @else {
      Editar
      }
    </button>


    <!--  <button mat-flat-button class="btn-tg w-full mt-6" [disabled]="!checkForm()" (click)="sendLogin()">entrar</button>-->
  </div>
</div>